import type { BaseTemplateConfig } from "@anggunpraya-templates/base/app/schemas/template";

/**
 * App config dasar untuk layer `base`.
 *
 * Nilai di sini adalah default umum yang boleh dioverride oleh template.
 * Bagian `template` tidak diisi di base, tetapi tipe-nya didaftarkan di bawah
 * agar setiap template bisa memakai `defineAppConfig()` dengan contract yang sama.
 */
export default defineAppConfig({
  layer: {
    name: "Hello from the base layer!",
  },
  toaster: {
    position: "top-right" as const,
    duration: 3500,
    max: 1,
  },
  tooltip: {
    delayDuration: 300,
  },
  ui: {
    colors: {
      primary: "green",
      neutral: "slate",
    },
    icons: {
      loading: "i-lucide-loader-circle",
    },
  },
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    layer?: {
      /** Nama proyek atau layer aktif yang ingin ditampilkan pada metadata app. */
      name?: string;
    };
    /** Contract shared untuk konfigurasi template aktif. */
    template?: BaseTemplateConfig;
  }
}
